module.exports = ""


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/comman-queue/comman-queue.component.html
// module id = ../../../../../src/app/comman-queue/comman-queue.component.html
// module chunks = main